import { LstDadosContasCadastradas } from "../../../../../interfaces/entities/Reembolso/DadosContaBeneficiario";
import { useAccessibility } from "../../../../../Store/contexts/AccessibilityContext";
import "./styles.css";

const AccountDataCard: React.FC<{ account: LstDadosContasCadastradas }> = ({ account }) => {

  const { fontSizeStyleAccessibility } = useAccessibility();

  return (
    <div className="registration-data-card-holder">
      <div className="registration-data-card">
        <div className="registration-data-row">
          <span style={fontSizeStyleAccessibility} className="registration-data-title">Dados da conta</span>
        </div>
        <div className="registration-data-row registration-data-row-secondary">
          <span style={fontSizeStyleAccessibility} className="registration-data-key">Tipo</span>
          <span style={fontSizeStyleAccessibility} className="registration-data-value">{account.indClassifConj === 'I' ? 'Individual' : 'Conjunta'}</span>
        </div>
        <div className="registration-data-row">
          <span style={fontSizeStyleAccessibility} className="registration-data-key">Titular da conta</span>
          <span style={fontSizeStyleAccessibility} className="registration-data-value">{account.nomeTitularConta}</span>
        </div>
        <div className="registration-data-row registration-data-row-secondary">
          <span style={fontSizeStyleAccessibility} className="registration-data-key">CPF do titular</span>
          <span style={fontSizeStyleAccessibility} className="registration-data-value">{account.cpfTitularConta}</span>
        </div>
        <div className="registration-data-row">
          <span style={fontSizeStyleAccessibility} className="registration-data-key">Banco</span>
          <span style={fontSizeStyleAccessibility} className="registration-data-value">{account.banco}</span>
        </div>
        <div className="registration-data-row registration-data-row-secondary">
          <span style={fontSizeStyleAccessibility} className="registration-data-key">Agência</span>
          <span style={fontSizeStyleAccessibility} className="registration-data-value">{account.agencia}</span>
        </div>
        <div className="registration-data-row">
          <span style={fontSizeStyleAccessibility} className="registration-data-key">Número da conta</span>
          <span style={fontSizeStyleAccessibility} className="registration-data-value">{account.numConta}{account.digConta}</span>
        </div>
        <div className="registration-data-row registration-data-row-secondary radius-bottom">
          <span style={fontSizeStyleAccessibility} className="registration-data-key">Tipo da conta</span>
          <span style={fontSizeStyleAccessibility} className="registration-data-value">{account.descrTipoConta}</span>
        </div>
      </div>
    </div>
  )
}

export default AccountDataCard;